import './Footer.scss';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import brandLogos from '../../assets/Tri-Brand_footer-2.png';
import PDFViewer from '../PDFViewer/PDFViewer';
import termsAndConditionsPDF from '../../assets/pdfs/2025-09 Accolade Terms & Conditions - EN - DRAFT.pdf';


export const Footer = () => {
  const { t, i18n } = useTranslation('common');
  const currentYear = new Date().getFullYear();
  const [showTermsPdf, setShowTermsPdf] = useState(false);

  const privacyPolicyUrl = i18n.language === 'fr'
    ? 'https://service.subzerowolfcove.ca/s/privacy-policy?language=fr&selected=true'
    : 'https://service.subzerowolfcove.ca/s/privacy-policy?language=en_US';

  return (
    <footer className="footer">
      <div className="footer__content">
        <div className="footer__copyright">
          <p>&copy; {t('footer.copyright')}, {currentYear}</p>
        </div>
        <div className="footer__logos">
          <img src={brandLogos} alt="Brand Logos" />
        </div>
        <nav className="footer__links">
          <a href={privacyPolicyUrl} target="_blank" rel="noopener noreferrer">{t('footer.cookies')}</a>
          <button onClick={() => setShowTermsPdf(true)} className="footer__link-button">{t('footer.terms')}</button>
        </nav>
        {showTermsPdf && (
          <PDFViewer
            pdfUrl={termsAndConditionsPDF}
            onClose={() => setShowTermsPdf(false)}
          />
        )}
      </div>
    </footer>
  );
};
